export default __webpack_public_path__ + "static/media/Renault.effbf6c2.png";